
/*
 * ============================================================================
 * Pegel
 * version 1.0
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2013, mikabo
 * All rights reserved.
 * ============================================================================
 */

var PLUGIN_NAME	= 'Pegel';
var VERSION		= '1.0';
var MKB			= MKB || {};

MKB.Pegel = (function(window, document, $) {

	'use strict';

	//=========================================================================
	// PRIVATE VARIABELS AND FUNCTIONS
	//=========================================================================

	var initialized = false;
	var preloader = '';

	var options = {

		debug					: true,
		el						: null,
		clickEvent				: false,
		getWasserstand			: null,
		url						: 'http://www.pegelonline.wsv.de/webservices/rest-api/v2/stations/HAMBURG-ST.PAULI.json?includeTimeseries=true&includeCurrentMeasurement=true'

	};

	var utils = {

		// fn to add blank (noOp) function for all console methods
		disableConsole: function (window) {

			var names = ["log", "debug", "info", "warn", "error",
				"assert", "dir", "dirxml", "group", "groupEnd", "time",
				"timeEnd", "count", "trace", "profile", "profileEnd"],
				i, l = names.length,
				noOp = function () {};
			window.console = {};
			for (i = 0; i < l; i = i + 1) {
				window.console[names[i]] = noOp;
			}
		},

		checkType: function(obj, /*string*/ type) {

			if (typeof obj == type) {

				return true;

			} else {

				utils.throwError('[ ' + obj.toString() + ' ] is not of this Type: [ ' + type + ' ]');
				return false;
			}
		},

		// Check for valids urls
		// From : http://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-an-url
		isUrl: function (str) {

			var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
			'(\\#[-a-z\\d_]*)?$','i'); // fragment locator
			if(!pattern.test(str)) {
				return false;
			} else {
				return true;
			}
		},

		extround: function (zahl,n_stelle) {
			zahl = (Math.round(zahl * n_stelle) / n_stelle);
			return zahl;
		},

		formatDate: function (value) {
			if(value < 10){
				value = '0' + value;
			}
			return value;
		},

		throwError: function( /*string*/ msg) {

			throw msg;
		}

	};

	//=========================================================================
	// CONSTRUCTOR
	//=========================================================================

	var Pegel = function(config) {

		// call disableConsole() if console is undefined or if in production
		if (!window.console || !options.debug) {
			utils.disableConsole(window);
		}

		//jQuery.support.cors = true;
		jQuery.extend(options, config);

		init();

	};

	var init = function(){


		if(!utils.isUrl(options.url)){

			//throw new Error('url is not valid.' + ' || ' +  PLUGIN_NAME);
			throw new Error('url is not valid.');
		}
		if(!utils.checkType(options.getWasserstand, 'function')){

			//throw new Error('callback must be type of function.' + ' || ' +  PLUGIN_NAME);
			throw new Error('callback must be type of function.');
		}

		preloader = '<img src="' + options.preloader + '">';

		getWasserstand(options.getWasserstand);

		if(options.clickEvent === true && options.el){
			events(options.getWasserstand);
		}
	};

	var events = function(callback){

		$(options.el).on('click', function(e){
			getWasserstand(callback);
		});
	};

	var getWasserstand = function (callback) {

		$(options.el).html(preloader);

		/*$.getJSON(options.url, function(data){

				var obj = {};
				var timestamp = data.timeseries[0].currentMeasurement.timestamp;
				var date = new Date(timestamp);

				obj.timestamp = utils.formatDate(date.getHours()) + ':' +  utils.formatDate(date.getMinutes()) + ' Uhr';
				obj.value = utils.extround(data.timeseries[0].currentMeasurement.value / 100, 100) + ' m';

				callback(obj);
			});*/

		$.ajax({
			//contentType: "application/json; charset=utf-8",
			type: 'GET',
			dataType: 'json',
			url: options.url,
			cache:false,
			crossDomain: true,
			success: function(data){

				var obj = {};
				var timestamp = data.timeseries[0].currentMeasurement.timestamp;
				var date = new Date(timestamp);

				obj.timestamp = utils.formatDate(date.getHours()) + ':' +  utils.formatDate(date.getMinutes()) + ' Uhr';
				obj.value = utils.extround(data.timeseries[0].currentMeasurement.value / 100, 100) + ' m';

				callback(obj);
			},
			error: function(xhr, status, errorThrown){

				//throw new Error('ajax call error: ' + errorThrown + ' || ' + PLUGIN_NAME);
				alert(errorThrown+'\n'+status+'\n'+xhr.statusText);
			}
		});


		/*var callbacks = $.Callbacks('once');//'once' ensures the callback list can only be fired once.
		callbacks.add(end);
		callbacks.fire(results);*/
	};

	//=========================================================================
	// PROTOTYPE AND PUBLIC FUNCTIONS
	//=========================================================================

	Pegel.prototype = {

		constructor: Pegel,

		getWasserstand: function (callback) {

			getWasserstand(callback);
		},

		version: function() {
			return {
				name	: NAME,
				version : VERSION
			};
		}
	};

	//=========================================================================
	// RETURN MODULE
	//=========================================================================

	return Pegel;

})(window, document, jQuery);

define("mkb.pegel", function(){});
